const Variants = ({ backgroundColor = '#efefef', color = '#e21e1e' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 183 98" id="Calque_2">
    <g id="Calque_1-2">
      <rect
        fill={backgroundColor}
        y="28"
        width="73"
        height="28"
        rx="7.75"
        ry="7.75"
      />
      <rect
        fill={backgroundColor}
        y="63"
        width="73"
        height="28"
        rx="7.75"
        ry="7.75"
      />
      <rect fill={color} x="110" width="73" height="28" rx="7.75" ry="7.75" />
      <rect
        fill={backgroundColor}
        x="110"
        y="35"
        width="73"
        height="28"
        rx="7.75"
        ry="7.75"
      />
      <rect
        fill={backgroundColor}
        x="110"
        y="70"
        width="73"
        height="28"
        rx="7.75"
        ry="7.75"
      />
    </g>
  </svg>
);

export default Variants;
